import React from "react";
import CheckoutNote from "./CheckoutNote";

export default function LowerShipping() {
  return (
    <CheckoutNote
      title="Lower Shipping Rates"
      icon="dollar-sign"
      backgroundColor="#F0F7F4"
      borderColor="#00AA00"
      color="#000"
    >
      We negotiated lower rates & have passed along the savings to you!
    </CheckoutNote>
  );
}
